import ConfigField from '../ConfigField';
import { NODE_CONFIG_FIELDS, WALLETTWO_EVENT_FIELDS } from '../../../constants';

export default function WalletTwoEventConfig({ data, onChange }) {
  const baseFields = NODE_CONFIG_FIELDS.trigger_wallettwo;
  const eventFields = data.event ? (WALLETTWO_EVENT_FIELDS[data.event] || []) : [];

  return (
    <div className="space-y-4">
      {baseFields.map((field) => (
        <div key={field.key}>
          <label className="block text-xs font-medium text-gray-600 mb-1.5">{field.label}</label>
          <ConfigField field={field} value={data[field.key]} onChange={(v) => onChange(field.key, v)} allData={data} onChangeField={onChange} />
        </div>
      ))}

      {eventFields.length > 0 && (
        <>
          <div className="h-px bg-gray-100 my-1" />
          <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wide">Event Configuration</p>
          {eventFields.map((field) => (
            <div key={field.key}>
              <label className="block text-xs font-medium text-gray-600 mb-1.5">{field.label}</label>
              <ConfigField field={field} value={data[field.key]} onChange={(v) => onChange(field.key, v)} allData={data} onChangeField={onChange} />
            </div>
          ))}
        </>
      )}

      {data.event && eventFields.length === 0 && (
        <p className="text-xs text-gray-400 text-center py-2">
          No additional configuration needed for this event.
        </p>
      )}
    </div>
  );
}
